import apiClient from "./client";

/** Public — submit a question (no auth). */
export const createSubmittedQuestion = async (payload) => {
  const response = await apiClient.post("/questions", payload);
  return response.data;
};

/** Admin — list submissions (JWT: SuperAdmin, Admin, Editor). */
export const getAdminSubmittedQuestions = async () => {
  const response = await apiClient.get("/questions/admin");
  return response.data;
};

/** Admin — delete submission (JWT: SuperAdmin, Admin, Editor). */
export const deleteAdminSubmittedQuestion = async (id) => {
  await apiClient.delete(`/questions/admin/${id}`);
};
